import { styled, Table, TableBody, TableHead } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'
import { Link } from 'react-router-dom'
import CustomTable from 'shared/components/CustomTable'
import {
   StyledTable,
   StyledTableCell,
   StyledTableHead,
   StyledTableHeadCell,
   StyledTableRow,
} from 'shared/components/StyledTableComponents'

const StyledLink = styled('a')(({ theme }) => ({
   textDecoration: 'none',
   color: 'black',
   fontWeight: 'bold',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
   },
}))

const StyledReactLink = styled(Link)(({ theme }) => ({
   textDecoration: 'none',
   color: 'black',
   fontWeight: 'bold',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
   },
}))

export default function PrivacyPolicy() {
   return (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            textAlign: 'justify',
            px: { lg: '24px', md: '24px', xs: '12px' },
         }}
      >
         <Typography textAlign="center" variant="h3" color="primary.dark">
            Polityka Prywatności
         </Typography>

         <Typography variant="h6">Podsumowanie</Typography>
         <Typography>
            Euromaster Polska sp. z o.o. zobowiązuje się do ochrony Twoich danych osobowych oraz do jasnego i
            przejrzystego informowania o tym, jakie informacje gromadzimy i w jaki sposób je wykorzystujemy. Niniejsze
            zasady wyjaśniają, w jaki sposób będą przez nas przetwarzane wszelkie dane osobowe, które zbieramy podczas
            korzystania z naszej strony internetowej lub usług cyfrowych, lub które nam przekazujesz.
         </Typography>
         <Typography>
            Prosimy o uważne zapoznanie się z poniższymi zasadami, aby zrozumieć nasze zasady i praktyki dotyczące
            danych osobowych użytkowników oraz sposób, w jaki będziemy je traktować.
         </Typography>
         <Typography>
            1 - Kim jesteśmy i jak można się z nami skontaktować
            <br /> 2 - Nasze witryny internetowe objęte niniejszą polityką prywatności <br />3 - Informacje o naszym
            Inspektorze Ochrony Danych Privacy Manager <br />4 - Inne polityki i informacje, z którymi należy się
            zapoznać <br />5 - Informacje, które możemy zbierać od Państwa <br />6 - Komunikacja marketingowa <br />7 -
            Informacje, które zbieramy o użytkownikach z innych miejsc <br />8 - Miejsce przechowywania danych osobowych{' '}
            <br />9 - Udostępnianie danych osobowych
            <br /> 10 - Przekazywanie danych osobowych za granicę
            <br /> 11 - Okres przechowywania danych osobowych <br />
            12 - Prawa użytkownika wynikające z przepisów o ochronie danych osobowych <br />
            13 - Co można zrobić, jeśli użytkownik nie jest zadowolony z tego, w jaki sposób wykorzystujemy jego dane
            osobowe? <br />
            14 - Informacje o bezpieczeństwie danych 15 - Zmiany w naszej Polityce prywatności
         </Typography>
         <Typography fontWeight="bold" variant="h6">
            1. Kim jesteśmy i jak można się z nami skontaktować
         </Typography>
         <Typography>
            Nasza pełna nazwa spółki to Euromaster Polska sp. z o.o. “Euromaster Polska sp. z o.o.” i kiedy korzystasz
            bezpośrednio z naszej strony internetowej i naszych usług, działamy jako Administrator Danych.
         </Typography>
         <Typography>Jeśli chcesz się z nami skontaktować, masz kilka możliwości:</Typography>
         <ul>
            <li>wysłać do nas wiadomość e-mail na adres: marketplace.smr@euromaster.pl</li>
            <li>możesz wysłać do nas list zaadresowany na adres: Domaniewska 45, 02-672 Warszawa</li>
            <li>możesz także skontaktować się z nami telefonicznie pod numerem + 48 22 395 62 90</li>
         </ul>
         <Typography fontWeight="bold" variant="h6">
            2. Nasze witryny internetowe objęte niniejszą polityką prywatności
         </Typography>
         <Typography>
            Informacje zawarte w niniejszej polityce mają zastosowanie do następujących witryn internetowych:
            http://smr.euromaster.pl/
         </Typography>
         <Typography fontWeight="bold" variant="h6">
            3. Informacje o naszym Inspektorze Ochrony Danych
         </Typography>
         <Typography>
            Wszyscy pracownicy Euromaster Polska sp. z o.o. są zaangażowani w ochronę i poszanowanie Państwa
            prywatności. Ponadto o ochronę danych osobowych dba Inspektorze ochrony Danych , który zajmuje się
            wszystkimi aspektami dotyczącymi danych osobowych w Euromaster Polska sp. z o.o.. Z Inspektorem Ochrony
            Danych można skontaktować się, wysyłając wiadomość e-mail na adres :{' '}
            <StyledLink href="mailto:rodo@euromaster.com" target="_blank">
               rodo@euromaster.com
            </StyledLink>
         </Typography>
         <Typography fontWeight="bold" variant="h6">
            4. Inne polityki i informacje, z którymi należy się zapoznać
         </Typography>
         <Typography>
            Mimo iż niniejszy dokument zawiera wszystkie informacje dotyczące sposobów zbierania i wykorzystywania
            Państwa danych osobowych za pośrednictwem naszych witryn internetowych, to zachęcamy również do zapoznania
            się z informacjami znajdującymi się pod innymi adresami.
         </Typography>
         <Typography>
            Polityka dotycząca plików cookie{' '}
            <StyledReactLink to="/cookies"> https://smr.euromaster.pl/cookies</StyledReactLink>
         </Typography>
         <Typography>
            Regulamin
            <StyledReactLink to="/terms-of-use"> https://smr.euromaster.pl/terms-of-use </StyledReactLink>
         </Typography>
         <ul>
            <li>Polityka dotycząca plików cookie</li>
         </ul>
         <Typography>
            Podczas korzystania z naszej strony internetowej oraz innych produktów i usług cyfrowych świadczonych przez
            Euromaster Polska sp. z o.o. , za pomocą plików cookie mogą być gromadzone dodatkowe informacje, które
            umożliwiają identyfikację użytkowników stron internetowych oraz cyfrowych produktów i usług Euromaster
            Polska sp. z o.o. . W Euromaster Polska sp. z o.o. obowiązuje oddzielna polityka dotycząca plików cookie
            oraz celu ich wykorzystywania przez Euromaster Polska sp. z o.o.. Zachęcamy do zapoznania się z polityką
            Euromaster Polska sp. z o.o. odnośnie plików cookie.
         </Typography>
         <ul>
            <li> Warunki użytkowania</li>
         </ul>
         <Typography>
            Nasze Warunki korzystania z witryny określają warunki korzystania z naszych witryn internetowych i należy je
            czytać razem z niniejszą Polityką prywatności. Z naszymi Warunkami korzystania z witryny można zapoznać się
            tutaj: <StyledReactLink to="/terms-of-use">https://smr.euromaster.pl/terms-of-use</StyledReactLink>
         </Typography>
         <ul>
            <li>Platformy połączone</li>
         </ul>
         <Typography>
            Nasza strona może zawierać linki hipertekstowe do i z naszych stron internetowych oraz platform cyfrowych
            naszych sieci partnerskich, reklamodawców, podmiotów stowarzyszonych i stron sieci społecznościowych.
            Korzystając z linków do którejkolwiek z tych stron internetowych, należy pamiętać, że obowiązują na nich
            odrębne polityki prywatności, a Euromaster Polska sp. z o.o. nie ponosi w związku z nimi żadnej
            odpowiedzialności. Przed podaniem jakichkolwiek danych osobowych w tych aplikacjach mobilnych należy
            zapoznać się z obowiązującą w nich polityką prywatności.
         </Typography>
         <Typography fontWeight="bold" variant="h6">
            5. Informacje, które możemy zbierać od Państwa
         </Typography>
         <Typography>Poniżej przedstawiamy informacje dotyczące:</Typography>
         <ul>
            <li>sposobu zbierania danych osobowych przez Euromaster Polska sp. z o.o.</li>
            <li>kategorii danych zbieranych przez Euromaster Polska sp. z o.o.</li>
            <li>sposobu wykorzystywania informacji zbieranych przez Euromaster Polska sp. z o.o.</li>
            <li>
               podstawy prawnej, na której Euromaster Polska sp. z o.o. opiera się w celu przetwarzania zbieranych
               informacji{' '}
            </li>
            <li>okresu przechowywania zebranych informacji oraz </li>
            <li>kategorii zbieranych danych</li>
         </ul>
         <Typography>
            Euromaster Polska sp. z o.o. może zbierać i przechowywać informacje dotyczące Państwa takie jak:
         </Typography>
         <StyledTable>
            <StyledTableHead>
               <StyledTableHeadCell>Zbierane dane</StyledTableHeadCell>
               <StyledTableHeadCell>Cel / czynność</StyledTableHeadCell>
               <StyledTableHeadCell>Rodzaj danych</StyledTableHeadCell>
               <StyledTableHeadCell>Podstawa prawna przetwarzania danych</StyledTableHeadCell>
               <StyledTableHeadCell>Okres przechowywania danych</StyledTableHeadCell>
            </StyledTableHead>
            <TableBody>
               <StyledTableRow>
                  <StyledTableCell>
                     Informacje podawane przez użytkownika podczas udziału w konkursach lub promocjach{' '}
                     <b>(„Dane konkursowe”)</b>
                  </StyledTableCell>
                  <StyledTableCell>
                     Aby umożliwić nam wysłanie użytkownikowi dalszych informacji o konkursie lub nagrodzie, jeśli jest
                     on zwycięzcą konkursu. O ile nie określimy inaczej podczas zbierania informacji o użytkowniku,
                     będziemy wykorzystywać te informacje wyłącznie w celu zarządzania i administrowania konkursami lub
                     promocjami.
                  </StyledTableCell>
                  <StyledTableCell>
                     <b>Dane Konkursowe</b> mogą obejmować na przykład imię i nazwisko oraz adres e-mail. W przypadku
                     wygrania nagrody możemy poprosić o podanie pełnego adresu, aby umożliwić nam wysłanie nagrody.
                  </StyledTableCell>
                  <StyledTableCell>
                     Wykonanie umowy pomiędzy użytkownikiem a nami dotyczącej udziału w konkursie lub promocji.
                  </StyledTableCell>
                  <StyledTableCell>
                     Jeśli jesteś zwycięzcą konkursu, usuniemy wszelkie zebrane dane nie później niż 6 miesięcy od daty
                     wysłania Ci nagrody. Wszelkie inne zebrane dane zostaną usunięte 3 miesiące po zakończeniu konkursu
                     lub promocji.
                  </StyledTableCell>
               </StyledTableRow>
               <StyledTableRow>
                  <StyledTableCell>
                     Informacje, które Państwo podają wypełniając ankietę, kwestionariusz lub przesyłając opinię lub
                     informacje zwrotne <b>(„Dane z opinii”).</b>
                  </StyledTableCell>
                  <StyledTableCell>
                     Zbieranie informacji na temat konkretnej kwestii, na przykład naszych usług lub opinii o produktach
                     / usługach. W wielu przypadkach ankiety i kwestionariusze są anonimowe, a Euromaster Polska sp. z
                     o.o. gromadzi dane osobowe wyłączenie w celach statystycznych. Jeśli tak nie jest, informujemy o
                     tym Państwa podczas zbierania informacji. Przy dostępności opcji opinii i informacji zwrotnych
                     Euromaster Polska sp. z o.o. może ujawniać na witrynie/stronie internetowej niektóre Państwa dane
                     osobowe. Zostaną wtedy Państwo o poinformowani o tym fakcie.
                  </StyledTableCell>
                  <StyledTableCell>
                     Te informacje mogą zawierać imię i nazwisko, adres e-mail oraz inne wymagane dane osobowe.
                  </StyledTableCell>
                  <StyledTableCell>
                     Jako podstawę prawną przetwarzania <b>Danych z opinii</b> Euromaster Polska sp. z o.o. podaje
                     uzasadnione interesy w monitorowaniu i ulepszaniu swoich produktów i usług świadczonych klientom
                     Euromaster Polska sp. z o.o. i użytkownikom produktów Euromaster Polska sp. z o.o. oraz w dzieleniu
                     się doświadczeniami klientów z odwiedzającymi witrynę Euromaster Polska sp. z o.o..
                  </StyledTableCell>
                  <StyledTableCell>
                     Mimo iż pragniemy zachować Państwa oceny i opinie, aby pomóc innym internautom, po upływie 3 lat
                     Euromaster Polska sp. z o.o. zanonimizuje lub usunie Państwa oceny i opinie. Wszelkie informacje
                     zebrane na podstawie ankiety lub kwestionariusza zostaną usunięte w terminie 3 lat od przesłania
                     przez Państwo do Euromaster Polska sp. z o.o.. Wszelkie przechowywane informacje będą jedynie
                     danymi statystycznymi.
                  </StyledTableCell>
               </StyledTableRow>
               <StyledTableRow>
                  <StyledTableCell>
                     Jeśli zarejestrują się Państwo do któregokolwiek z naszych produktów lub usług cyfrowych za
                     pośrednictwem konta, poprosimy wtedy o informacje umożliwiające Euromaster Polska sp. z o.o.
                     zidentyfikowanie Państwa i dostarczenie Państwu tych produktów i usług <b>(„Dane z konta”)</b>.
                  </StyledTableCell>
                  <StyledTableCell>
                     <b>Dane z konta</b> będą przetwarzane w celu obsługi naszej witryny, świadczenia usług cyfrowych,
                     do których Państwo zarejestrowaliście się, komunikowania się z Państwem odnośnie cyfrowych
                     produktów i usług oraz utrzymywania kopii zapasowych naszych serwisów.
                  </StyledTableCell>
                  <StyledTableCell>
                     <b>Dane z konta</b> będą zawierać Państwa imię i nazwisko i adres e-mail. Możemy również poprosić
                     Państwa o ustawienie hasła, pozwalającego na bezpieczne logowanie się na Państwa konto.
                  </StyledTableCell>
                  <StyledTableCell>
                     Podstawą prawną przetwarzania <b>Danych z konta</b> jest wykonanie zawartej między Państwem a
                     Euromaster Polska sp. z o.o. umowy na dostarczanie cyfrowych produktów i usług.
                  </StyledTableCell>
                  <StyledTableCell>
                     Euromaster Polska sp. z o.o. będzie przechowywał <b>Dane z konta</b> tak długo, jak Państwa konto w
                     Euromaster Polska sp. z o.o. będzie aktywne. Jeśli nie będą Państwo korzystać z konta przez 24
                     miesiące, Euromaster Polska sp. z o.o. usunie Państwa dane z konta, aby nie przechować Państwa
                     danych osobowych dłużej niż to konieczne. Oczywiście zawsze można utworzyć nowe konto.
                  </StyledTableCell>
               </StyledTableRow>
               <StyledTableRow>
                  <StyledTableCell>
                     Informacje przekazywane nam przez użytkownika podczas korzystania z usług lokalizacyjnych, np.
                     lokalizatora dealerów <b>(„Dane o lokalizacji”)</b>.
                  </StyledTableCell>
                  <StyledTableCell>
                     Informacje te są wykorzystywane do identyfikacji dealerów w danej lokalizacji.
                  </StyledTableCell>
                  <StyledTableCell>
                     Aby korzystać z niektórych naszych usług, wymagamy podania lokalizacji lub korzystamy z lokalizacji
                     przeglądarki lub urządzenia użytkownika. Należy zapoznać się z polityką prywatności przeglądarki
                     lub systemu operacyjnego.
                  </StyledTableCell>
                  <StyledTableCell>
                     Podstawą prawną przetwarzania <b>Danych o lokalizacji</b> jest wykonanie umowy między użytkownikiem
                     a nami o dostarczeniu produktu cyfrowego i usług.
                  </StyledTableCell>
                  <StyledTableCell>
                     Nie uzyskujemy żadnych <b>Danych o lokalizacji</b> i dlatego ich nie przechowujemy.
                  </StyledTableCell>
               </StyledTableRow>
               <StyledTableRow>
                  <StyledTableCell>
                     Informacje, które Państwo przekazują Euromaster Polska sp. z o.o. podczas komunikowania się z nami,
                     np. wysyłając e-mail lub kontaktując się z Euromaster Polska sp. z o.o. za pośrednictwem witryny
                     lub poprzez funkcję czatu na żywo na naszej stronie internetowej <b>(„Dane z komunikacji”)</b>
                  </StyledTableCell>
                  <StyledTableCell>
                     Euromaster Polska sp. z o.o. wykorzystuje te informacje w celu udzielenia Państwu odpowiedzi lub
                     udzielenia odpowiedzi na Państwa komentarze, żądania i zapytania
                  </StyledTableCell>
                  <StyledTableCell>
                     Te informacje mogą zawierać Państwa imię i nazwisko, adres e-mail oraz inne dane osobowe, które są
                     niezbędne do komunikacji z Państwem.
                  </StyledTableCell>
                  <StyledTableCell>
                     Podstawą prawną przetwarzania danych z komunikacji są uzasadnione interesy Euromaster Polska sp. z
                     o.o. w świadczeniu Państwu wsparcia i odpowiadaniu na korespondencję otrzymywaną od Państwa.
                  </StyledTableCell>
                  <StyledTableCell>
                     Euromaster Polska sp. z o.o. będzie przechowywać <b>Dane komunikacyjne</b> tak długo, jak będzie to
                     konieczne do zapewniania Państwu wsparcia w kwestii, w której Państwo kontaktują się z nami. Po
                     rozpatrzeniu sprawy usuniemy dotyczące Państwa <b>Dane z komunikacji</b> w terminie 6 miesięcy.
                  </StyledTableCell>
               </StyledTableRow>
               <StyledTableRow>
                  <StyledTableCell>
                     Jeśli poproszą Państwo o dodatkowe informacje od Euromaster Polska sp. z o.o. , zapisując się na
                     otrzymywanie newslettera lub komunikacji marketingowej Euromaster Polska sp. z o.o.{' '}
                     <b>(„Dane marketingowe”).</b> Więcej informacji w punkcie 6 poniżej.
                  </StyledTableCell>
                  <StyledTableCell>
                     <b>Dane marketingowe</b> są przetwarzane w celu przesyłania Państwu odpowiednich powiadomień i/lub
                     newsletterów i/lub komunikacji marketingowej.
                  </StyledTableCell>
                  <StyledTableCell>
                     Aby móc przesyłać te informacje, Euromaster Polska sp. z o.o. poprosi Państwa o podanie imienia
                     oraz adresu e-mail.
                  </StyledTableCell>
                  <StyledTableCell>Podstawą prawną przetwarzania danych jest Państwa zgoda.</StyledTableCell>
                  <StyledTableCell>
                     Euromaster Polska sp. z o.o. nie będzie przechowywać danych marketingowych przez okres dłuższy niż
                     3 lata od naszego ostatniego kontaktu.
                  </StyledTableCell>
               </StyledTableRow>
            </TableBody>
         </StyledTable>
         <Typography fontWeight="bold">Informacje podawane dobrowolnie</Typography>
         <Typography>
            W niektórych przypadkach, podczas podawania nam informacji (np. informacji opisanych w powyższych
            scenariuszach) Euromaster Polska sp. z o.o. może poprosić Państwo o podanie dodatkowych, podawanych
            dobrowolnie informacji. Te informacje, oznaczone jako opcjonalne, służą Euromaster Polska sp. z o.o. do
            lepszego zrozumienia naszych klientów i oferowania im bardziej zindywidualizowanych usług.
         </Typography>
         <Typography fontWeight="bold">Dane statystyczne</Typography>
         <Typography>
            Ponadto Euromaster Polska sp. z o.o. zbiera i wykorzystuje zagregowane dane, takie jak dane statystyczne lub
            demograficzne (dalej <b>„Dane zagregowane”</b>). <b>Dane zagregowane</b> mogą pochodzić z Państwa danych
            osobowych, ale w żaden sposób nie ujawniają Państwa tożsamości. Euromaster Polska sp. z o.o. może na
            przykład zagregować dane dotyczące korzystania ze strony i dane z urządzenia, aby obliczyć odsetek
            użytkowników naszej witryny, którzy korzystają z poszczególnych funkcji w nich dostępnych. Dane zagregowane
            są wykorzystywane wyłącznie do celów biznesowych.
         </Typography>
         <Typography fontWeight="bold">Wrażliwe dane osobowe</Typography>
         <Typography>
            Mimo iż Euromaster Polska sp. z o.o. nie prosi o przekazanie wrażliwych danych osobowych, to w naszej
            witrynie znajdują się sekcje, w których można zamieścić dodatkowe informacje, na przykład podczas
            przesyłania opinii. Wpisując tekst opinii, należy podawać wyłącznie informacje, których chcemy udzielić,
            pamiętając, że niektóre z nich mogą być danymi wrażliwymi. Zamieszczając opinię lub komentarz na naszej
            witrynie, należy pamiętać, że treść opinii lub komentarza będzie widoczna dla innych użytkowników aplikacji.
         </Typography>
         <Typography fontWeight="bold">Dzieci i dane osobowe</Typography>
         <Typography>
            Niniejsza witryna nie jest przeznaczona do użytku przez dzieci i świadomie nie gromadzimy danych dotyczących
            dzieci. Jeśli dowiemy się, że posiadamy jakiekolwiek informacje dotyczące dzieci poniżej 15 roku życia,
            podejmiemy wszelkie działania niezbędne do zachowania zgodności z przepisami o ochronie danych osobowych, w
            tym, jeśli będzie to konieczne, usuniemy te informacje. Jeśli użytkownik dowie się, że jego dziecko (poniżej
            15 roku życia) przekazało nam swoje dane osobowe bez zgody użytkownika, prosimy o jak najszybsze
            poinformowanie nas o tym fakcie za pośrednictwem poczty elektronicznej na adres [do uzupełnienia], abyśmy
            mogli podjąć odpowiednie działania.
         </Typography>
         <Typography fontWeight="bold" variant="h6">
            6. Komunikacja marketingowa
         </Typography>
         <Typography>
            Komunikację marketingową lub newslettery Euromaster Polska sp. z o.o. będą Państwo otrzymywać od nas
            wyłącznie (i), jeżeli będą Państwo sobie tego życzyć, (ii) jeżeli są Państwo naszym klientem pod warunkiem,
            że takowa komunikacja będzie dotyczyć podobnych produktów lub usług lub (iii) takowa komunikacja będzie
            związana z Państwa działalnością biznesową.
         </Typography>
         <Typography>
            W związku z tym Euromaster Polska sp. z o.o. będzie wykorzystywać informacje otrzymane od Państwa
            ograniczające się zazwyczaj wyłącznie do imienia i adresu e-mail.
         </Typography>
         <Typography>
            W każdym przypadku mogą Państwo zrezygnować z subskrypcji lub marketingu bezpośredniego w dowolnym momencie
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            (i) klikając znajdującą się na dole każdej otrzymanej od Euromaster Polska sp. z o.o. komunikacji
            marketingowej opcję rezygnacji z subskrypcji lub
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            (ii) kontaktując się z Euromaster Polska sp. z o.o. e-mailowo lub listownie na adres podany w niniejszym
            dokumencie.
         </Typography>
         <Typography>
            Zazwyczaj komunikację marketingową wysyłamy do odbiorców do momentu ich rezygnacji z otrzymywania takiej
            komunikacji. Jeżeli jednak przez dłuższy czas nie otrzymamy od Państwa wiadomości lub nie otworzą Państwo
            e-maili od Euromaster Polska sp. z o.o. w ciągu 3 lat, to Państwa dane zostaną usunięte z bazy danych
            Euromaster Polska sp. z o.o. . Subskrypcję wiadomości można wznowić w dowolnym momencie.
         </Typography>
         <Typography>
            Co pewien czas możemy również wykorzystywać Dane o użytkowaniu i urządzeniu z witryny, aby przekazywać
            Państwu rekomendacje i zalecenia online dotyczące towarów lub usług, które mogą Państwa zainteresować. Jest
            to niezbędne w kontekście uzasadnionego interesu Euromaster Polska sp. z o.o. w doskonaleniu naszych
            produktów i usług oraz rozwoju firmy.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            7. Informacje, które zbieramy o użytkownikach z innych miejsc
         </Typography>
         <Typography>
            Aby móc dostarczać Państwu nasze usługi, Euromaster Polska sp. z o.o. może otrzymywać dotyczące Państwa dane
            osobowe z innych źródeł w następujący sposób:
         </Typography>
         <ul>
            <li>
               Możemy otrzymywać informacje dotyczące Państwa, jeżeli korzystacie Państwo z innych stron internetowych
               Euromaster Polska sp. z o.o. lub innych produktów i/lub usług Euromaster Polska sp. z o.o. . Ściśle
               współpracujemy również z podmiotami zewnętrznymi (w tym na przykład z partnerami biznesowymi,
               podwykonawcami w zakresie usług technicznych, usług płatniczych, analitykami, dostawcami informacji
               dotyczących wyszukiwania i biurami informacji kredytowych), od których możemy otrzymywać informacje
               dotyczące Państwa. Jako podstawę prawną przetwarzania tych danych Euromaster Polska sp. z o.o. podaje
               uzasadnione interesy w monitorowaniu i doskonaleniu swojej witryny, produktów i usług.
            </li>
            <li>
               Informacje z logów z serwerów internetowych Euromaster Polska sp. z o.o., takie jak na przykład
               informacje o Państwa komputerze, systemie operacyjnym, przeglądarce oraz adres IP. Euromaster Polska sp.
               z o.o. może również zbierać informacje o wyszukiwaniach w naszej witrynie i interakcji z przesyłanymi
               Państwu wiadomościami e-mail, na przykład ich otwierania („Dane o użytkowaniu i urządzeniu”). Euromaster
               Polska sp. z o.o. wykorzystuje informacje tego typu do administrowania systemem i analizowania sposobu
               korzystania z naszych witryn i platform cyfrowych przez odwiedzających. Dzięki temu możemy także zapewnić
               najlepszą infrastrukturę online do interakcji z działaniami, jakie podejmujemy w Internecie. Jako
               podstawę prawną przetwarzania tych danych Euromaster Polska sp. z o.o., podaje uzasadnione interesy w
               monitorowaniu i doskonaleniu swojej witryny, produktów i usług.
            </li>
            <li>
               Zgodnie z powyższym, Euromaster Polska sp. z o.o., zbiera informacje na temat sposobu korzystania z
               naszej witryny, produktów i usług cyfrowych za pomocą plików cookie lub innych podobnych rozwiązań
               technologicznych przechowywanych na Państwa urządzeniu. Pliki cookie, zapisywane na twardym dysku Państwa
               komputera, zawierają informacje, dzięki którym możemy ulepszać nasze aplikacje mobilne i dostarczać
               Państwu lepszych i bardziej spersonalizowanych usług. Zachęcamy do zapoznania się z polityką Euromaster
               Polska sp. z o.o., dotyczącą plików cookie{' '}
               <StyledReactLink to="/cookies">https://smr.euromaster.pl/cookies</StyledReactLink>{' '}
            </li>
            <li>
               Informacje, które uzyskujemy o użytkowniku z innych renomowanych źródeł informacji. Informacje te będą
               zbierane z publicznie dostępnych rejestrów, takich jak KRS i Centralna Ewidencja i Informacja o
               Działalności Gospodarczej.
            </li>
         </ul>
         <Typography variant="h6" fontWeight="bold">
            8. Miejsce przechowywania danych osobowych
         </Typography>
         <Typography>
            Wszystkie informacje, które nam Państwo przekazują są przechowywane na bezpiecznych serwerach znajdujących
            się na terytorium EOG.
         </Typography>
         <Typography>
            Pomimo dokładania wszelkich starań w zakresie zapewnienia bezpieczeństwa Państwa danych osobowych,
            przekazywanie ich przez Internet nie jest całkowicie bezpieczne. Euromaster Polska sp. z o.o. oraz
            usługodawcy Euromaster Polska sp. z o.o., dokładają wszelkich starań, aby chronić Państwa dane osobowe, ale
            przekazywanie informacji Euromaster Polska sp. z o.o., odbywa się na wyłączne ryzyko użytkownika.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            9. Udostępnianie danych osobowych
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o., udostępnia Państwa dane osobowe wyłącznie osobom, które muszą znać te
            informacje, aby wykonywać swoje obowiązki służbowe. Euromaster Polska sp. z o.o., może udostępniać Państwa
            dane osobowe:
         </Typography>
         <ul>
            <li>
               <b>Wewnątrz Grupy Michelin</b> - Euromaster Polska sp. z o.o., może ujawnić Państwa dane osobowe każdemu
               podmiotowi należącemu do Grupy Michelin, czyli naszym spółkom zależnym, naszej ostatecznej spółce
               holdingowej i jej spółkom zależnym w zakresie niezbędnym do realizacji tych samych celów wstępnego
               przetwarzania opisanych w niniejszym dokumencie.
            </li>
            <li>
               <Typography>
                  <b>Usługodawcom</b> - Euromaster Polska sp. z o.o., może udostępniać Państwa dane osobowe wybranym
                  usługodawcom, z których usług Euromaster Polska sp. z o.o. może korzystać w celu realizacji Państwa
                  żądania lub świadczenia Państwu usług. Ci usługodawcy działają jako przetwarzający dane w imieniu
                  Euromaster Polska sp. z o.o., i świadczą usługi w zakresie IT i administrowania systemami, takie jak
                  na przykład usługi hostingu witryn i poczty elektronicznej oraz zarządzania zamieszczanymi ocenami i
                  recenzjami.
               </Typography>
               <Typography>
                  Wspomniani usługodawcy są prawnie zobowiązani do zachowania poufności i zabezpieczenia otrzymywanych
                  danych osobowych oraz do korzystania z nich wyłącznie zgodnie z wytycznymi otrzymywanymi od Euromaster
                  Polska sp. z o.o..
               </Typography>
            </li>
         </ul>
         <Typography>
            Euromaster Polska sp. z o.o. może także udostępniać Państwa dane osobowe stronom trzecim:
         </Typography>
         <Typography sx={{ ml: '24px' }}>(i) Na mocy prawa</Typography>
         <Typography>
            W przypadku, gdy Euromaster Polska sp. z o.o. będzie zobowiązany na mocy prawa do ujawnienia lub
            udostępnienia Państwa danych osobowych lub gdy będzie to konieczne do egzekwowania lub zastosowania warunków
            i realizacji innych umów Euromaster Polska sp. z o.o. lub w celu ochrony praw, mienia lub dla zapewnienia
            bezpieczeństwa Grupy Michelin, naszych klientów lub innych osób. W związku z tym Euromaster Polska sp. z
            o.o. może ujawniać Państwa dane osobowe naszym profesjonalnym doradcom, którzy są zobowiązani do zachowania
            poufności.
         </Typography>
         <Typography sx={{ ml: '24px' }}>(ii) Na podstawie Państwa zgody</Typography>
         <Typography>
            Strony trzecie mogą zbierać informacje o Państwie odnośnie witryny, produktów lub usług Euromaster Polska
            sp. z o.o. za pomocą plików cookie lub podobnych technologii, na przykład w celu wyświetlania
            spersonalizowanych reklam lub profilowania. Zgodnie z polityką Euromaster Polska sp. z o.o. dotyczącą plików
            cookie konieczna jest Państwa zgoda na pliki cookie. Możesz przeczytać ją w tym miejscu
            <StyledReactLink to="/cookies">https://smr.euromaster.pl/cookies </StyledReactLink>
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            10.Przekazywanie danych osobowych za granicę
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o. należy do międzynarodowej grupy posiadającej bazy danych w różnych krajach, w
            których prowadzi działalność. Euromaster Polska sp. z o.o. może przekazywać Państwa dane osobowe do baz
            danych należących do Grupy Michelin lub do zewnętrznych partnerów grupy z siedzibą za granicą.
         </Typography>
         <Typography>
            Z uwagi na różny poziom ochrony danych w poszczególnych krajach, Euromaster Polska sp. z o.o. nie przekazuje
            Państwa danych osobowych spółkom należącym do Grupy Michelin ani firmom zewnętrznym spoza Unii Europejskiej,
            chyba że te spółki oferują taki sam lub zbliżony do Euromaster Polska sp. z o.o. poziom ochrony danych
            osobowych.
         </Typography>
         <Typography>
            W odniesieniu do przekazywania danych osobowych wewnątrz Euromaster Polska sp. z o.o. przyjęliśmy wewnętrzne
            zasady regulujące przekazywanie danych osobowych z Unii Europejskiej lub Europejskiego Obszaru
            Gospodarczego.
         </Typography>
         <Typography>
            Przekazywanie danych osobowych poza grupę podlega Wiążącym Regułom Korporacyjnym podwykonawców lub odbywa
            się na mocy umów zawierających klauzule Komisji Europejskiej odnoszące się do dostawców mających siedzibę
            poza UE celem zagwarantowania zbliżonego poziomu ochrony danych jak w kraju ich gromadzenia.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            11. Okres przechowywania danych osobowych
         </Typography>
         <Typography>
            Zasadniczo Euromaster Polska sp. z o.o. nie przechowuje Państwa danych osobowych w żadnym celu lub celach
            dłużej, niż jest to konieczne do realizacji celów, dla których zostały zebrane, w tym także dla celów
            spełnienia wymogów prawnych, księgowych lub sprawozdawczych. Szczegółowe informacje odnośnie czasu
            przechowywania danych osobowych znajdują się w punkcie 4 powyżej.
         </Typography>
         <Typography>
            Aby ustalić odpowiedni czas przechowywania danych osobowych, bierzemy pod uwagę ich ilość, charakter i
            wrażliwość, potencjalne ryzyko szkód wynikłych z nieuprawnionego wykorzystania lub ujawnienia danych
            osobowych, cele, dla których osiągnięcia dane osobowe będą przetwarzane, możliwość osiągnięcia tych celów za
            pomocą innych środków oraz mające zastosowanie wymogi prawne.
         </Typography>
         <Typography>
            W niektórych przypadkach mogą Państwo zwrócić się do nas z żądaniem usunięcia Państwa danych osobowych.
            Szczegółowe informacje dotyczące prawa do usunięcia danych znajdują się poniżej.
         </Typography>
         <Typography>
            W niektórych przypadkach Euromaster Polska sp. z o.o. może anonimizować Państwa dane osobowe (aby
            uniemożliwić powiązanie danych z Państwem) w celach badawczych lub statystycznych, w którym to przypadku
            Euromaster Polska sp. z o.o. może wykorzystywać te dane bez ograniczenia czasowego i bez powiadamiania
            Państwa o tym fakcie.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            Prawa użytkownika wynikające z przepisów o ochronie danych osobowych
         </Typography>
         <Typography>
            Zgodnie z europejskimi przepisami dotyczącymi ochrony danych osobowych uzyskują Państwo określone prawa w
            zakresie przetwarzania danych.
         </Typography>
         <Typography>
            Prawo do bycia poinformowanym o zbieraniu danych
            <br />
            Prawo dostępu do danych osobowych
            <br />
            Prawo do sprostowania Państwa danych osobowych
            <br />
            Prawo do usunięcia Państwa danych osobowych
            <br />
            Prawo do ograniczenia przetwarzania danych <br />
            Prawo do przenoszenia danych osobowych
            <br />
            Prawo do sprzeciwu wobec przetwarzania danych
         </Typography>
         <Typography fontWeight="bold">Prawo do bycia poinformowanym o zbieraniu danych</Typography>
         <Typography>
            Mają Państwo prawo do bycia poinformowanym o sposobie zbierania i przetwarzania Państwa danych osobowych
            przez Euromaster Polska sp. z o.o. wraz z informacjami o Euromaster Polska sp. z o.o. sposobie
            wykorzystywania przez nas Państwa danych osobowych oraz informacjami o Państwa prawach w odniesieniu do
            Państwa danych osobowych. Wszystkie niezbędne informacje w tym zakresie znajdują się w niniejszym
            dokumencie.
         </Typography>
         <Typography fontWeight="bold">Prawo do dostępu do danych osobowych</Typography>
         <Typography>
            Przysługuje Państwu prawo do dostępu do zgromadzonych przez Euromaster Polska sp. z o.o. informacji
            dotyczących Państwa. Na mocy tego prawa Euromaster Polska sp. z o.o. może poinformować Państwa, czy Państwa
            dane osobowe są przetwarzane i zapewnić Państwu dostęp do tych danych osobowych.
         </Typography>
         <Typography fontWeight="bold">Prawo do sprostowania Państwa danych osobowych</Typography>
         <Typography>
            Jeżeli Państwa dane osobowe są nieprawidłowe lub niekompletne, mają Państwo prawo do ich poprawienia i
            uaktualnienia. Jeżeli Euromaster Polska sp. z o.o. ujawnił Państwa dane stronom trzecim, to w miarę
            możliwości poinformujemy te strony o aktualizacji Państwa danych osobowych. Możecie Państwo aktualizować
            przechowywane przez Euromaster Polska sp. z o.o. dane osobowe, kontaktując się z nami jednym ze sposobów
            opisanych w niniejszym dokumencie.
         </Typography>
         <Typography fontWeight="bold">Prawo do usunięcia Państwa danych osobowych</Typography>
         <Typography>
            Jeżeli nie ma powodu, aby Euromaster Polska sp. z o.o. nadal przetwarzał Państwa dane osobowe, mają Państwo
            prawo zażądać usunięcia tych danych. Okoliczności, w których można zażądać wyegzekwowania prawa do „bycia
            zapomnianym”, dotyczą sytuacji, gdy dane osobowe nie są już potrzebne do realizacji celów, do których
            zostały pierwotnie zebrane lub przetwarzane i sytuacji, gdy wycofano zgodę na przetwarzanie danych.
         </Typography>
         <Typography>
            Istnieją pewne wyjątkowe okoliczności, w których prawo do bycia zapomnianym nie ma zastosowania. Zapraszamy
            do kontaktu po szczegółowe informacje na ten temat.
         </Typography>
         <Typography fontWeight="bold">Prawo do ograniczenia przetwarzania danych osobowych</Typography>
         <Typography>
            Mają Państwo prawo zażądać „zablokowania” lub ograniczenia przetwarzania Państwa danych osobowych. Na
            Państwa żądanie Euromaster Polska sp. z o.o. zaprzestanie dalszego przetwarzania Państwa danych osobowych.
         </Typography>
         <Typography fontWeight="bold">Prawo do przenoszenia danych osobowych</Typography>
         <Typography>
            Jeżeli zechcą Państwo przenieść dotyczące Was dane osobowe do innego usługodawcy lub sporządzić kopię tych
            danych na własny użytek, macie Państwo prawo zażądać przeniesienia Państwa danych osobowych.
         </Typography>
         <Typography fontWeight="bold">Prawo do sprzeciwu wobec przetwarzania danych osobowych</Typography>
         <Typography>
            Mają Państwo prawo zażądać od Michelin zaprzestania przetwarzania Państwa danych osobowych dla potrzeb
            marketingowych. Zazwyczaj informujemy osoby, których dane dotyczą (przed zebraniem danych) o zamiarze
            wykorzystania danych do celów marketingowych lub o zamiarze ujawnienia danych osobowych w tym celu stronom
            trzecim. Mają Państwo prawo do wyrażenia sprzeciwu wobec przetwarzania Państwa danych osobowych, zaznaczając
            właściwe pola na formularzach, których używamy do zbierania danych osobowych.
         </Typography>
         <Typography>
            Z prawa tego można również skorzystać w dowolnym momencie, kontaktując się z nami pod adresem
            <StyledLink href="mailto:rodo@euromaster.com" target="_blank">
               rodo@euromaster.com
            </StyledLink>
         </Typography>
         <Typography fontWeight="bold">
            Szczegółowe informacje odnośnie praw związanych z ochroną danych osobowych
         </Typography>
         <Typography>
            Szczegółowych informacji na temat praw związanych z ochroną danych osobowych udziela właściwy Urząd Ochrony
            Danych Osobowych:
         </Typography>
         <ol>
            <li> Czechy: Úřad pro ochranu osobních údajů, www.uoou.cz</li>
            <li>Estonia: Data Protection Inspectorate, www.aki.ee</li>
            <li>Litwa: The State Data Protection Inspectorate, vdai.lrv.lt/lt/</li>
            <li>Łotwa: Data State Inspectorate, www.dvi.gov.lv</li>
            <li>Polska: Prezes Urzędu Ochrony Danych Osobowych, https://uodo.gov.pl/</li>
            <li>Słowacja: Úrad na ochranu osobných údajov, www.dataprotection.gov.sk</li>
         </ol>
         <Typography variant="h6" fontWeight="bold">
            13.Co można zrobić, jeśli użytkownik nie jest zadowolony z tego, w jaki sposób wykorzystujemy jego dane
            osobowe?
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o. zobowiązuje się do ochrony i poszanowania Państwa prywatności. Jeżeli jednak
            będą Państwo niezadowoleni ze sposobu zbierania lub przetwarzania Państwa danych osobowych przez Euromaster
            Polska sp. z o.o. lub chcieliby zasięgnąć dodatkowych informacji odnośnie przysługujących Państwu praw,
            można się z nami skontaktować w następujący sposób:
         </Typography>
         <Typography>
            - można wysłać do nas wiadomość e-mail na adres:{' '}
            <StyledLink href="mailto:rodo@euromaster.com" target="_blank">
               rodo@euromaster.com{' '}
            </StyledLink>
         </Typography>
         <Typography>
            - Mogą Państwo wysłać do nas list zaadresowany na adres: Domaniewska 45, 02-672 Warszawa
         </Typography>
         <Typography>
            Będziemy z Państwem współpracować w celu rozwiązania wszelkich problemów i starać się jak najszybciej
            odpowiadać na wszelkie pytania.
         </Typography>
         <Typography>Mogą Państwo również wnieść skargę do właściwego Urzędu Ochrony Danych Osobowych:</Typography>
         <ol>
            <li>Czechy: Úřad pro ochranu osobních údajů, www.uoou.cz</li>
            <li>Estonia: Data Protection Inspectorate, www.aki.ee</li>
            <li>Litwa: The State Data Protection Inspectorate, vdai.lrv.lt/lt/</li>
            <li>Łotwa: Data State Inspectorate, www.dvi.gov.lv</li>
            <li>Polska: Prezes Urzędu Ochrony Danych Osobowych, https://uodo.gov.pl/</li>
            <li>Słowacja: Úrad na ochranu osobných údajov, www.dataprotection.gov.sk</li>
         </ol>
         <Typography variant="h6" fontWeight="bold">
            Informacje o bezpieczeństwie danych
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o. wdrożył środki mające na celu ochronę prywatności, bezpieczeństwa i
            integralności danych osobowych. Dostęp do danych osobowych mają wyłącznie pracownicy i usługodawcy, którzy
            muszą znać te informacje i zostali przeszkoleni w zakresie przestrzegania zasad poufności.
         </Typography>
         <Typography>
            Na handlowych witrynach Euromaster Polska sp. z o.o. zbierane są informacje bankowe niezbędne do realizacji
            efektywnych, zgodnych z prawem i bezpiecznych procesów płatności. Wdrożone środki mogą wykorzystywać
            szyfrowanie SSL (uniemożliwiające odczytanie danych przez inne osoby) odbywające się podczas gromadzenia lub
            przesyłania danych poufnych. Niniejsze informacje są wykorzystywane wyłącznie do celów realizacji płatności
            online i nie są przechowywane.
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o. zapewnia, że Państwa dane osobowe nie zostaną zmienione, uszkodzone ani
            udostępnione nieuprawnionym osobom trzecim.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            Zmiany w polityce prywatności
         </Typography>
         <Typography>
            Niniejsza polityka prywatności może podlegać okresowym modyfikacjom. Wszelkie zmiany wprowadzane w
            niniejszej polityce będą publikowane na tej stronie. Osoby posiadające konto w nazwa spółki mogą zostać
            powiadomione o wszelkich zmianach drogą mailową lub podczas logowania do konta.
         </Typography>
         <Typography>
            <b>Data:</b> 4.03.25
         </Typography>
      </Box>
   )
}
